import { formatDateTime } from "@/lib/constants";

export const ActivityTimeline = ({ items = [] }) => {
  if (!items.length) {
    return <p className="text-sm text-muted-foreground">No activity yet.</p>;
  }
  return (
    <div data-testid="application-status-timeline" className="relative pl-6 space-y-5">
      <span className="absolute left-[5px] top-2 bottom-2 w-px bg-border" />
      {items.map((item, i) => (
        <div key={i} className="relative">
          <span className={`absolute -left-6 top-1.5 h-2.5 w-2.5 rounded-full ${i === 0 ? "bg-primary" : "bg-border"}`} />
          <p className="text-sm font-medium leading-tight">{item.status || item.title}</p>
          {item.note && <p className="text-xs text-muted-foreground mt-0.5">{item.note}</p>}
          <p className="text-[11px] text-muted-foreground mt-0.5">
            {item.changed_by_name && <span>{item.changed_by_name} · </span>}
            <span className="font-mono">{formatDateTime(item.at || item.created_at)}</span>
          </p>
        </div>
      ))}
    </div>
  );
};
